import { useMutation, useQueryClient } from '@tanstack/react-query';

import { bopsApi } from '@Network';

const useRedeemJourneyToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) => bopsApi.redeemJourneyToken(token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agent-conversations'] });
    },
  });
};

export default useRedeemJourneyToken;
